import { useTranslation } from 'react-i18next';
import { Flex, Typography } from 'antd';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';
import { kccThemeConstants } from 'config/theme/kccTheme/kccTheme';

interface ErrorMessageProps {
  isOneAttemptLeft: boolean;
}

export const ErrorMessage = ({ isOneAttemptLeft }: ErrorMessageProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Flex vertical>
      <Flex
        align="start"
        gap={6}
        style={{ marginTop: kccThemeConstants.SPACING.XS, marginLeft: kccThemeConstants.SPACING.XS }}
      >
        <SvgIcon name="warningCritical" />
        <Typography.Text type="danger" style={{ margin: 0 }}>
          {isOneAttemptLeft
            ? t('serviceRequestPage.resend.oneAttemptLeft')
            : t('serviceRequestPage.verification.codeError')}
          <br />
        </Typography.Text>
      </Flex>
    </Flex>
  );
};
